import Vue from 'vue'

Vue.mixin({
    methods: {
        // Prevent Non Numbers keys from being inputed into a text field
        preventKeys(event) {
            if (event.keyCode == 17 || event.keyCode == 86 || event.keyCode == 91) {
                return event;
            } else if ((event.keyCode >= 48 && event.keyCode <= 57) || (event.keyCode >= 96 && event.keyCode <= 105) || event.keyCode == 8 || event.keyCode == 9) {
                return event;
            } else {
                return event.preventDefault();
            }
        }
    }
})